import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import { learnpathsTranslationsQueries } from '@/http/api/learnpathsTranslations'
import { LearnpathsSummaryDetailsTabPanel } from '@/learnpaths-summary/components/LearnpathsSummaryDetailsTabPanel/LearnpathsSummaryDetailsTabPanel'
import { LearnpathsTranslationsEditor } from '@/learnpaths-translations/components/LearnpathsTranslationsEditor/LearnpathsTranslationsEditor'
import { LearnpathsTranslationsLoader } from '@/learnpaths-translations/components/LearnpathsTranslationsManager/LearnpathsTranslationsLoader'
import { LearnpathsTranslationsManager } from '@/learnpaths-translations/components/LearnpathsTranslationsManager/LearnpathsTranslationsManager'
import { CONTENT_LOCALE } from '@/locale/constants'
import type { ContentLocale } from '@/locale/types/Locale'

const searchSchema = v.object({
  lang_edit: v.optional(v.picklist(CONTENT_LOCALE)),
})

export const Route = createFileRoute(
  '/company/_management/learnpaths/overview/$learnpathId/translations',
)({
  validateSearch: searchSchema,
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureQueryData(
      learnpathsTranslationsQueries.managedLanguages(params.learnpathId),
    ),
  component: TranslationsTab,
  pendingComponent: LearnpathsTranslationsLoader,
})

function TranslationsTab() {
  const navigate = Route.useNavigate()
  const { learnpathId } = Route.useParams()
  const { lang_edit } = Route.useSearch()

  const setEditLanguage = (language?: ContentLocale) =>
    navigate({ search: (prev) => ({ ...prev, lang_edit: language }) })

  return (
    <LearnpathsSummaryDetailsTabPanel>
      <LearnpathsTranslationsManager
        learnpathId={learnpathId}
        onEditLanguageChange={setEditLanguage}
      />
      {lang_edit && (
        <LearnpathsTranslationsEditor
          learnpathId={learnpathId}
          targetLanguage={lang_edit}
          onClose={() => setEditLanguage(undefined)}
          onTargetLanguageChange={setEditLanguage}
        />
      )}
    </LearnpathsSummaryDetailsTabPanel>
  )
}
